import { Injectable, inject } from '@angular/core';
import { GraphApiQueryRef, GraphApiService } from '@nuso/common/data-access-api';
import { CpaasTn } from '@nuso/cpaas/types';
import { addCpaasVendorMutation, CpaasVendorsQuery, customerDidsExtensionsQuery, importTnsForCustomerMutation, syncServiceExtensionsMutation, uploadTnsForCustomerUsMutation } from './cpaas-tn.queries';

export interface CustomerExtension {
  did: string;
  name: string | null;
  extension: string | null;
}
import { CpaasTnsForCustomerQuery } from './cpaas-tn.queries';

@Injectable({
  providedIn: 'root'
})
export class CpaasTnService {
  private graphApi = inject(GraphApiService);


  cpaasTnsForCustomer(customerId: number) {
    return this.graphApi.watchQuery<CpaasTn[]>({
      query: CpaasTnsForCustomerQuery,
      variables: {
        input: {
          customerId
        }
      }
    });
  }

  cpaasTnsForCustomerQueryRef(customerId: number) {
    return this.graphApi.watchQueryRef<CpaasTn[]>({
      query: CpaasTnsForCustomerQuery,
      variables: {
        input: {
          customerId
        }
      },
      fetchPolicy: 'network-only'
    });
  }

  cpaasTnsForCustomerQuery(customerId: number) {
    return this.graphApi.watchQuery<CpaasTn[]>({
      query: CpaasTnsForCustomerQuery,
      variables: {
        input: {
          customerId
        }
      },
      fetchPolicy: 'network-only'
    })
  }

  cpaasVendorsQuery() {
    return this.graphApi.watchQuery<{ vendorList: string[] }>({
      query: CpaasVendorsQuery,
      fetchPolicy: 'network-only'
    })
  }

  addCpaasVendor(vendor: string) {
    return this.graphApi.mutate({
      mutation: addCpaasVendorMutation,
      variables: {
        vendor
      }
    })
  }


  customerExtensions(customerId: number) {
    return this.graphApi.watchQuery<CustomerExtension[]>({
      query: customerDidsExtensionsQuery,
      variables: {
        customerId
      },
      fetchPolicy: 'network-only',
    });
  }

  syncServiceExtensions(serviceId: string) {
    return this.graphApi.mutate({
      mutation: syncServiceExtensionsMutation,
      variables: {
        input: {
          serviceId
        }
      }
    });
  }

  importTnsForCustomer(customerId: number, tns: string[], vendor: string) {
    return this.graphApi.mutate({
      mutation: importTnsForCustomerMutation,
      variables: {
        input: {
          customerId,
          dids: tns,
          vendor,
        }
      }
    })
  }

  uploadTnsForCustomerUs(customerId: number, tns: string[]) {
    return this.graphApi.mutate({
      mutation: uploadTnsForCustomerUsMutation,
      variables: {
        input: {
          customerId,
          dids: tns,
        }
      }
    });
  }

}
